/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./reseller-profil-edit.scss";
import Header from "../../../../../widget/index";
import UseEditResellerProfilCtr from "../../../../../../controller/profil-ctr/use-edit-profil-reseller-ctr";
import UseEditController from "../../../../../../controller/profil-ctr/use-edit-profil-ctr";
import { ISV } from "../../../../../../service/constant/index";
import ModalPhoto from "../../../../../widget/modal/modal-photo";
import { concatString, fileUrl, refaCtoNullKey } from "../../../../../../utils";
import { contact } from "../../../../../../utils/country_phone";
import { COMPANY_OVERVIEW, KEY_COMPETITIVE_DIFFERENCIATORS } from "./type";
import * as Block from "./block-edit-reseller/index";

import * as ModalEdit from "../../profil-modal-edit/index";
import Footer from "../../../../../widget/footer/footer";
export default function profilResellerEdit() {
  const providerUseEditResellerProfilCtr = { ...UseEditResellerProfilCtr() };
  const providerUseEditProfilCtr = { ...UseEditController() };
  const renderEmailLabel = (roles: Array<string>) => {
    if (roles.indexOf(ISV) !== -1) return "Primary email";
    return "Email";
  };

  const dialCode = (() => {
    if (
      providerUseEditResellerProfilCtr?.userState?.phone_number_code !== "" &&
      providerUseEditResellerProfilCtr?.userState?.phone_number_code !== null
    ) {
      return contact.filter(
        (element) =>
          element.code ===
          providerUseEditResellerProfilCtr?.userState?.phone_number_code
      )[0].dial_code;
    }
    return "";
  })();

  return (
    <div className="isv edit profilIsv">
      <Header />
      <div className="contentProfil">
        <div className="row profilHead m-0 justify-content-between">
          <div className="col-lg-8 col-12 infoProfil d-flex">
            <div
              className={`imageProfil ${
                providerUseEditResellerProfilCtr?.userState.file_name
                  ? "overnoBg"
                  : ""
              }`}
            >
              <a
                onClick={() =>
                  providerUseEditResellerProfilCtr?.setProfilUser(true)
                }
              >
                <div className="absphoto">
                  <span className="icon-edit-full"></span>
                  Edit photo
                </div>
                <img
                  src={fileUrl(
                    providerUseEditResellerProfilCtr?.userState.file_name
                  )}
                  alt=""
                />
              </a>
            </div>
            <div className="aboutProfil">
              <a
                onClick={() => providerUseEditProfilCtr?.setShow(true)}
                className="editItem"
              >
                Edit
                <span className="icon-edit-full"></span>
              </a>
              <ul className="ulListInfo">
                <li>
                  <div className="label">Full name</div>
                  <div className="infoLabel">
                    {concatString(
                      providerUseEditResellerProfilCtr?.userState.first_name,
                      providerUseEditResellerProfilCtr?.userState.last_name,
                      " "
                    )}
                  </div>
                </li>
                <li>
                  <div className="label">Location</div>
                  <div className="infoLabel">
                    {concatString(
                      providerUseEditResellerProfilCtr?.userState?.country
                        ?.country_name,
                      providerUseEditResellerProfilCtr?.userState?.city
                    )}
                  </div>
                </li>
                <li>
                  <div className="label">Job title</div>
                  <div className="infoLabel">
                    {refaCtoNullKey(
                      providerUseEditResellerProfilCtr?.userState?.job_title,
                      "-"
                    )}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-12 guest-action">
            <a
              onClick={() => providerUseEditResellerProfilCtr?.goToProfil()}
              className="editDoneIsv"
            >
              Done editing
            </a>

            <div className="guest-company-logo">
              <img
                src={fileUrl(
                  providerUseEditResellerProfilCtr?.companyResellerState
                    ?.photo_profil
                )}
                alt="Reseller page logo"
              />
              <a
                onClick={() =>
                  providerUseEditResellerProfilCtr?.setLogoShow(true)
                }
              >
                <span className="icon-edit-full"></span>Edit your Company logo
              </a>
            </div>
          </div>
        </div>
        <div className="row otherInfoProfil m-0 justify-content-end">
          {/* <div className="col-12 infoInvestoronly">
            <span className="icon-locked"></span>
            Only investors and technology partners can view this information.
            Your personal details will never be published publicly.
          </div> */}

          <div className="col-lg-8 col-12 contact-info">
            <div className="boxEditProfil mb-2">
              <a
                className="editItem"
                onClick={(e) => {
                  e.preventDefault();
                  providerUseEditResellerProfilCtr?.setContactShow(true);
                }}
              >
                Edit
                <span className="icon-edit-full"></span>
              </a>
              <h3 className="title">Contact information</h3>
              <ul className="ulListInfo smallLabel">
                <li>
                  <div className="label">
                    {renderEmailLabel(
                      providerUseEditResellerProfilCtr?.userState?.roles
                    )}
                  </div>
                  <div className="infoLabel">
                    {providerUseEditResellerProfilCtr?.userState?.email}
                  </div>
                </li>
                <li>
                  <div className="label">Phone number</div>
                  <div className="infoLabel">
                    {dialCode === "" ? <></> : <>{"(" + dialCode + ") "}</>}
                    {refaCtoNullKey(
                      providerUseEditResellerProfilCtr?.userState?.phone,
                      "-"
                    )}
                  </div>
                </li>
                <li>
                  <div className="label">LinkedIn</div>
                  <div className="infoLabel">
                    <a
                      target="_blank"
                      href={
                        "https://www.linkedin.com/in/" +
                        refaCtoNullKey(
                          providerUseEditResellerProfilCtr?.userState?.linkedin,
                          "-"
                        )
                      }
                    >
                      {refaCtoNullKey(
                        providerUseEditResellerProfilCtr?.userState?.linkedin,
                        "-"
                      )}
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Company details */}
          <Block.BlockCompany dataSource={providerUseEditResellerProfilCtr} />
          {/* Company overview */}
          <Block.BlockAbout
            dataSource={providerUseEditResellerProfilCtr}
            type={COMPANY_OVERVIEW}
          />
          {/* software Solution*/}
          <Block.BlockSolution dataSource={providerUseEditResellerProfilCtr} />
          {/* Key competiticedifferenciators */}
          <Block.BlockAbout
            dataSource={providerUseEditResellerProfilCtr}
            type={KEY_COMPETITIVE_DIFFERENCIATORS}
          />
          {/* Targeted industry */}
          <Block.BlockTargetedIndustry
            dataSource={providerUseEditResellerProfilCtr}
          />
          {/* Geography targeted market */}
          <Block.BlockGeographyTarget
            dataSource={providerUseEditResellerProfilCtr}
          />
        </div>
      </div>
      {/* Edit contact */}
      <ModalEdit.ModalEditContactUser
        contactShow={providerUseEditResellerProfilCtr?.contactShow}
        setContactShow={() =>
          providerUseEditResellerProfilCtr?.setContactShow(false)
        }
        cancelChange={() => providerUseEditResellerProfilCtr?.cancelChange()}
        dataSource={providerUseEditResellerProfilCtr}
      />

      <ModalEdit.ModalEditCompanyPageReseller
        dataSource={providerUseEditResellerProfilCtr}
      />
      <ModalEdit.ModalEditInfoUser
        {...providerUseEditProfilCtr}
        showEditModal={providerUseEditProfilCtr.Show}
      />

      {/* Edit about user */}
      <ModalEdit.ModalEditOverview
        dataSource={providerUseEditResellerProfilCtr}
      />
      <ModalEdit.ModalEditDifferentiator
        dataSource={providerUseEditResellerProfilCtr}
      />

      {/* Edit software solution */}
      <ModalEdit.ModalEditSolution
        dataSource={providerUseEditResellerProfilCtr}
      />

      {/** Edit targeted industry */}
      <ModalEdit.ModalEditIndustry
        dataSource={providerUseEditResellerProfilCtr}
      />

      {/**Edit Geography target market */}
      <ModalEdit.ModalEditGeographyTarget
        dataSource={providerUseEditResellerProfilCtr}
      />

      {/* Edit Photo de profil */}
      <ModalPhoto
        changeHandler={(p: any) =>
          providerUseEditResellerProfilCtr?.changeHandler(p)
        }
        isShowImage={providerUseEditResellerProfilCtr?.profilUser}
        hideSelectedFile={() =>
          providerUseEditResellerProfilCtr?.hideSelectedFile()
        }
        fileUrl={providerUseEditResellerProfilCtr?.userState.file_name}
        selectedFile={providerUseEditResellerProfilCtr?.selectedFile}
        handleBtn={() => providerUseEditResellerProfilCtr?.handleBtn()}
        fileRef={providerUseEditResellerProfilCtr?.fileRef}
        updateUserDetail={(p: any) =>
          providerUseEditResellerProfilCtr?.updateUserDetail(p)
        }
        isLoaderShow={providerUseEditResellerProfilCtr?.isLoaderShow}
        setShowImage={(p: boolean) =>
          providerUseEditResellerProfilCtr?.setProfilUser(p)
        }
        restorePhotoChange={() =>
          providerUseEditResellerProfilCtr?.restorePhotoChange()
        }
      />

      <ModalPhoto
        changeHandler={(p: any) =>
          providerUseEditResellerProfilCtr?.changeLogoHandler(p)
        }
        isShowImage={providerUseEditResellerProfilCtr?.logoShow}
        hideSelectedFile={() =>
          providerUseEditResellerProfilCtr?.hideLogoSelected()
        }
        fileUrl={
          providerUseEditResellerProfilCtr?.companyResellerState?.photo_profil
        }
        selectedFile={providerUseEditResellerProfilCtr?.selectedFileLogo}
        handleBtn={() => providerUseEditResellerProfilCtr?.handleBtn()}
        fileRef={providerUseEditResellerProfilCtr?.fileRef}
        updateUserDetail={(p: any) =>
          providerUseEditResellerProfilCtr?.updateCompanyResellerDetails(p)
        }
        isLoaderShow={providerUseEditResellerProfilCtr?.isLoaderShow}
        setShowImage={(p: boolean) =>
          providerUseEditResellerProfilCtr?.setLogoShow(p)
        }
        restorePhotoChange={() =>
          providerUseEditResellerProfilCtr?.restorePhotoChange()
        }
      />
      <Footer />
    </div>
  );
}
